/**
 * @author jakubmaslon
 * @since 2021-9-7
 */

import * as React from "react";
import styled from "styled-components";

import { rem } from "@ui/helpers";

import slugifyFacade from "@services/SlugifyFacade";

interface Key {
  color: string;
  text: string;
}

interface KeyProps {
  keys: Key[];
}

const MapLegend = (props: KeyProps): React.ReactElement => (
  <div>
    {props.keys.map(key => (
      <KeyItem key={slugifyFacade(key.text)}>
        <Pill color={key.color} />
        <KeyText>{key.text}</KeyText>
      </KeyItem>
    ))}
  </div>
);

export { MapLegend };

const KeyItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${props => props.theme.margins.base};

  &:last-child {
    margin-bottom: 0;
  }
`;

const Pill = styled.div<{ color: string }>`
  width: ${rem(16)};
  height: ${rem(16)};
  margin-right: ${props => props.theme.margins.base};
  border-radius: ${props => props.theme.border.radius.base};
  background: ${props => props.color};

  ${props => props.theme.breakpoints.tablet} {
    width: ${rem(40)};
  }
`;

const KeyText = styled.div`
  font-size: ${props => props.theme.fonts.sizes.caption};
`;
